exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchbox {\n  margin-right: 20px;\n  width: 135px;\n}\n.odd{\n    background-color:#ffffff ;\n}\n.even{\n    background-color:#e6e6e6;\n}\n.customPage {\n  text-align: center;\n  font-size: 18px;\n}\n\n.ngx-pagination {\n  padding-top: 10px;\n  padding-bottom: 15px;\n}\ntable.bgborder, table.bgborder > thead > tr > th, table.bgborder > tbody > tr > td {\n    border: 1px solid #848a87;\n}\n.sort {\n  cursor: pointer;\n}\n.sort-icon {\n  padding: 5px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/projects/list/project-list.component.css
// module id = ../../../../../src/app/projects/list/project-list.component.css
// module chunks = main